import sdk from './sdk';

export default sdk;
module.exports = sdk;



// WEBPACK FOOTER //
// ./src/index.js